import { injectIntl } from "react-intl";

import { intlShape, ListItem } from "lcm-iot-commons";
import { apiKeyShape } from "../../shapes/apiKeysShape";
import {
  apiKeyIconClassName,
  apiKeyStatusIconClassName,
} from "../../utils/statusUtils";

type Props = {
  intl: intlShape;
  apiKey: apiKeyShape;
};

export function ApiKeyItem({ apiKey, intl }: Props) {
  const description = apiKey.description ? `, ${apiKey.description}` : "";
  const authenticationType = `${intl.formatMessage({ id: "label.authentication_type" })}: ${intl.formatMessage({ id: `enum.authentication_type.${apiKey.authenticationType}` })}`;

  const apiSecret = apiKey.apiSecret ? (
    <div className="list-item-details">
      <span>
        {intl.formatMessage({ id: "label.api_secret" })}:{apiKey.apiSecret}
      </span>
    </div>
  ) : null;

  return (
    <ListItem
      id={`apiKey-item-${apiKey.authenticationType}`}
      title={apiKey.apiKey}
      description={
        <>
          <span className={apiKeyStatusIconClassName(apiKey.disabled)} />
          <span>
            {authenticationType}
            {description}
          </span>
          {apiSecret}
        </>
      }
      icon={apiKeyIconClassName()}
    />
  );
}

export default injectIntl(ApiKeyItem);
